import { FC } from 'react';
import StepTitle from './StepTitle';

interface IPaymentTitleProps {
  freeReview?: boolean;
}

const PaymentTitle: FC<IPaymentTitleProps> = ({ freeReview }) => (
  <StepTitle
    title={freeReview ? 'Review & Submit' : 'Complete Payment'}
    description={freeReview
      ? 'Review your job credit and submit. Your job will go live within 15 minutes.'
      : 'All transactions are secure and encrypted. Your job will go live within 15 minutes and appear across BevNET, Nosh, Brewbound, and Nombase.'}
  />
);

export default PaymentTitle;
